import { render, staticRenderFns } from "./Devize_de_aprobat_list.vue?vue&type=template&id=0dcd8229&scoped=true&"
import script from "./Devize_de_aprobat_list.vue?vue&type=script&lang=js&"
export * from "./Devize_de_aprobat_list.vue?vue&type=script&lang=js&"
import style0 from "./Devize_de_aprobat_list.vue?vue&type=style&index=0&id=0dcd8229&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd8229",
  null
  
)

export default component.exports